import { useEffect } from "react";
import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import useUser from "../Context/hook/useUser";
import { AuthLayout } from "../Layout/AuthLayout";
import { ResetPassword } from "../Pages/User/ResetPassword";
import { ConfirmEmail } from "../Pages/auth/ConfirmEmail";
import { VerifyEmail } from "../Pages/auth/VerifyEmail";
import { ErrorPage } from "../Pages/ErrorPage";
import { User } from "../Pages/User/User";
import { ParksRouter } from "./ParksRouter";
import PrivacyPoliciesPage from "../Pages/PrivacyPoliciesPage/PrivacyPoliciesPage";
import { ChangePassword } from "../Pages/auth/ChangePassword";
import LandingPageParques from "../Pages/LandingPageParques";
import { useSelector } from "react-redux";
import ReclamacionUsuario from "../Components/ReclamacionesForm";
//import HistorialCompras from "../Components/HistorialCompras";

export const AppRouter = () => {
  const { isAuth, getUser } = useUser();
  const wasFromPay = useSelector((state) => state.ui.fromPay);
  const parkId = useSelector((state) => state.ui.parkId);

  useEffect(() => {}, []);

  const NoAuthenticatedRoute = ({ children, redirectTo }) => {
    const { key: keyLocation } = useLocation();
    const isInitialLocation = keyLocation === "default";
    const to = isInitialLocation ? "/" : -1;

    return isAuth() ? <Navigate to={to} /> : children;
  };

  const PrivateRoute = ({ children, redirectTo, path }) => {
    let verify = getUser()?.emailVerify;
    let changePassword = getUser()?.changePassword;
    return !isAuth() ? (
      <Navigate to={"/login"} state={{ pre: path }} />
    ) : isAuth() && !verify ? (
      <Navigate to={{ pathname: "/verify" }} />
    ) : isAuth() && changePassword ? (
      <Navigate to={{ pathname: "/change-password" }} />
    ) : wasFromPay ? (
      <Navigate to={{ pathname: `/detail/payment/${parkId}` }} />
    ) : (
      children
    );
  };

  const VerificationNotification = () => {
    const { key: keyLocation } = useLocation();
    const isInitialLocation = keyLocation === "default";
    const to = isInitialLocation ? "/" : -1;

    let verify = getUser()?.emailVerify;
    return isAuth() && !verify ? <VerifyEmail /> : <Navigate to={to} />;
  };

  const VerifyChangePassword = () => {
    const { key: keyLocation } = useLocation();
    const isInitialLocation = keyLocation === "default";
    const to = isInitialLocation ? "/" : -1;
    let changePassword = getUser()?.changePassword;
    return isAuth() && changePassword ? (
      <ChangePassword />
    ) : (
      <Navigate to={to} />
    );
  };

  return (
    <HashRouter>
      <Routes>
        <Route index element={<LandingPageParques />} />
        <Route path="politicas" element={<PrivacyPoliciesPage />} />
        <Route path="terminos" element={<PrivacyPoliciesPage />} />
        <Route path="reclamacion" element={<ReclamacionUsuario />} />
        {/* <Route path="historialcompras" element={<HistorialCompras />} /> */}
        <Route
          path="user"
          element={
            <PrivateRoute redirectTo={"/"}>
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="user/reset-password"
          element={
            <PrivateRoute redirectTo={"/"}>
              <ResetPassword />
            </PrivateRoute>
          }
        />

        <Route
          path="login/*"
          element={
            <NoAuthenticatedRoute>
              <AuthLayout />
            </NoAuthenticatedRoute>
          }
        ></Route>

        <Route path="*" element={<ParksRouter />} />

        <Route element={<AuthLayout />}>
          <Route path="verify" element={<VerificationNotification />} />
        </Route>
        <Route element={<AuthLayout />}>
          <Route path="client/confirmEmail/:token" element={<ConfirmEmail />} />
        </Route>
        <Route element={<AuthLayout />}>
          <Route path="change-password" element={<VerifyChangePassword />} />
        </Route>
        <Route path="*" element={<ErrorPage></ErrorPage>} />
      </Routes>
    </HashRouter>
  );
};
